import * as React from 'react';
import { Datagrid, ListProps, TextField } from 'react-admin';
import './TagDatagrid.scss';

export const TagDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="tags-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="title" label="TITLE"/>
		</Datagrid>
	);
};
